// extracted by mini-css-extract-plugin
export default {"container":"JourneyStats_container__s7F1t"};